v-container
  v-row
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")
        v-card
          v-card-text
            //- Title
            v-row
              v-col(cols="12")
                h2.text-h4.mb-4(v-html="$t('title')")
                h3.text-h6.mb-4.text-grey(v-html="$t('subtitle')")

            //- What Causes Need
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('causes.heading')")
                p.text-body-1.mb-3(v-html="$t('causes.text')")

            v-divider.my-4

            //- What is Ectropion Repair
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('whatIsRepair.heading')")
                p.text-body-1.mb-3(v-html="$t('whatIsRepair.text')")

            v-divider.my-4

            //- How Will Surgery Affect
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('visionAppearance.heading')")
                p.text-body-1.mb-3(v-html="$t('visionAppearance.text1')")
                p.text-body-1.mb-3(v-html="$t('visionAppearance.text2')")

            v-divider.my-4

            //- Major Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('risks.heading')")
                p.text-body-1.mb-3(v-html="$t('risks.text')")

            v-divider.my-4

            //- Alternatives
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('alternatives.heading')")
                p.text-body-1.mb-3(v-html="$t('alternatives.text')")

            v-divider.my-4

            //- Anesthesia
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('anesthesia.heading')")
                p.text-body-1.mb-3(v-html="$t('anesthesia.text')")

            v-divider.my-4

            //- Patient's Acceptance of Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('acceptance.heading')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('acceptance.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Offered Copy Checkbox
            v-row
              v-col(cols="12")
                v-checkbox(v-model="form.offeredCopy" :label="$t('common.offeredCopy')" :rules="[form.validCheck('offeredCopy')]")

            //- Surgery Selection
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('surgery.text')")
            v-row
              v-col(cols="12" md="6")
                v-select(v-model="form.lowerLidSide" :label="$t('surgery.lowerLid')" :items="form._attributes.lowerLidSide.options.parse.args" :rules="[form.validCheck('lowerLidSide')]")

            v-divider.my-6

            //- Signature Section
            v-row
              v-col(cols="12")
                NameDateSignature(
                  v-model:name="form.name"
                  v-model:date="form.date"
                  v-model:signature="form.signature"
                  :name_rules="[form.validCheck('name')]"
                  :date_rules="[form.validCheck('date')]"
                  :signature_rules="[form.validCheck('signature')]"
                )

          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") {{ $t('common.submit') }}
